let getters = {
    error: (state) => {
        return state.error;
    },
    user: (state) => {
        return state.user;
    },
    locations: (state) => {
        return state.locations;
    },
    jewelOptions: (state) => {
        return state.jewelOptions;
    },
    valuationIndexOptions: (state) => {
        return state.valuationIndexOptions;
    },
    valuationIndexResult: (state) => {
        return state.valuationIndexResult;
    },
    valuationEstimateResult: (state) => {
        return state.valuationEstimateResult;
    },
    valuationIndexTables: (state) => {
        return state.valuationIndexTables;
    },
};
export default getters;
